var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonRunMirror(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.25V18.75L10.5 16.5L6.75 14.25Z",
    fill: "#C75F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12C10.725 12 12.75 14.025 12.75 16.5C12.75 18.975 10.725 21 8.25 21C5.775 21 3.75 18.975 3.75 16.5C3.75 14.025 5.775 12 8.25 12ZM8.25 10.5C4.95 10.5 2.25 13.2 2.25 16.5C2.25 19.8 4.95 22.5 8.25 22.5C11.55 22.5 14.25 19.8 14.25 16.5C14.25 13.2 11.55 10.5 8.25 10.5Z",
    fill: "#C75F92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5V9H19.5V19.5H16.5V21H19.5C20.325 21 21 20.325 21 19.5V4.5C21 3.675 20.325 3 19.5 3H4.5C3.675 3 3 3.675 3 4.5ZM4.5 7.5V4.5H19.5V7.5H4.5Z",
    fill: "#C75F92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonRunMirror);
export default __webpack_public_path__ + "static/media/carbon_run-mirror.e1c651cfd9a60a240ae2ac9d28268dd0.svg";
export { ForwardRef as ReactComponent };